var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.602871,
    y: 0.602871,
    width: 17.7943,
    height: 17.7943,
    rx: 8.89713,
    stroke: "#BABCBE",
    strokeWidth: 1.20574
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Dot",
    cx: 9.64598,
    cy: 9.64598,
    r: 3.21531,
    fill: "#BABCBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon);
export default __webpack_public_path__ + "static/media/step-icon.b5de6da8ca4bd0c66383c7e703e381ef.svg";
export { ForwardRef as ReactComponent };